module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAkCAMAAADW3miqAAAAAXNSR0IB2cksfwAAADZQTFRFAAAAv7+/v7+/v7+/v7+/v7+/v7+/v7+/19fX7+/v+/v7////v7+/w8PDv7+/v7+/v7+/v7+/gqZFagAAABJ0Uk5TADB/v+//b6//////cP+AwPCwCSoajgAAAI1JREFUeJzt1DsOhDAMBFAbPJAfibn/ZTcQ0DbekHYlpn6y3MwQ1fA0C4zIPDFdWSxwu6WZFXA+RCPBO2A9TMLmLdHiN6T6D9AxVUGYMlzPxOiQqfQPHacKCcyfvwkQAvomRuBFL/pnpM9F0LFKDZWT9anmymODQbT3p2dvA5X094hpuqeOczGdlnzO4QdI2zC7/4yi+QAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/list-rectangle@2x.png
// module id = 849
// module chunks = 0